import { FC } from 'react';
import { IonIcon } from '@ionic/react';
import { playCircleOutline } from 'ionicons/icons';

// Empty-state shown in the list drawer when the Playlist filter is active but
// the user has not saved any EGMs to their playlist yet.
const PlaylistEmptyNotice: FC = () => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '24px',
      padding: '40px 24px 24px',
      textAlign: 'center',
    }}
  >
    <h2
      style={{
        width: '292px',
        maxWidth: '100%',
        margin: 0,
        color: '#FFF',
        textAlign: 'center',
        fontFamily: 'Heebo',
        fontSize: '30px',
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: '100%',
        letterSpacing: '-0.6px',
      }}
    >
      Playlist is Empty
    </h2>

    <div
      style={{
        alignSelf: 'stretch',
        color: '#FFF',
        textAlign: 'center',
        fontFamily: 'Heebo',
        fontSize: '18px',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: 'normal',
        letterSpacing: '-0.54px',
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
      }}
    >
      <p style={{ margin: 0 }}>You currently have no games in to your playlist.</p>
      <p style={{ margin: 0 }}>
        Creating a playlist is a great way to plan your next casino visit. It is an quick and easy
        way to compare slots and locate them on the map.
      </p>
      <p style={{ margin: 0 }}>
        Just click the{' '}
        <IonIcon
          icon={playCircleOutline}
          style={{ fontSize: '20px', verticalAlign: 'middle' }}
        />{' '}
        icon on any slot card or look for the “Add to Playlist” icon or action elsewhere in the
        app.
      </p>
    </div>
  </div>
);

export default PlaylistEmptyNotice;
